// extracted by mini-css-extract-plugin
export var quote = "NewsQuoteBlock-module--quote--TPqL8";
export var text = "NewsQuoteBlock-module--text---+XTa";
export var author = "NewsQuoteBlock-module--author--E9GkB";
export var info = "NewsQuoteBlock-module--info--OgZdI";
export var image = "NewsQuoteBlock-module--image--qFROs";